import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

/**
 * Padded, bordered panel with optional extra classes.
 *
 * @example
 * ```html
 * <lib-ui-card class="rounded-lg max-w-md">
 *   <h2 class="text-lg font-semibold">Title</h2>
 *   <p class="text-sm text-gray-600 dark:text-gray-400">Body copy.</p>
 * </lib-ui-card>
 * ```
 */
@Component({
  selector: 'lib-ui-card',
  imports: [CommonModule],
  template: `
    <div
      class="h-full w-full border border-gray-300 dark:border-gray-800 shadow-xs p-4 transition-colors duration-300"
      [ngClass]="class()"
    >
      <ng-content></ng-content>
    </div>
  `,
})
export class Card {
  /**
   * Extra Tailwind classes merged onto the root element via `ngClass`.
   * @defaultValue `'rounded-md'`
   */
  class = input<string>('rounded-md');
}
